export const MAX_REGULAR_ACCESS_DELAY_DAYS = 365
